export default __webpack_public_path__ + "static/tab-img10-c92b9dc98282140166c80967ef20b3aa.png";